module.exports = __webpack_public_path__ + "./docs/img/big-icon-const.3e67df33b84717cf521ed264ab5d0293.svg";